import React from 'react';

const Computing = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_4418_7409)">
        <path
          d="M14.97 22.75H8.96997C3.53997 22.75 1.21997 20.43 1.21997 15V9C1.21997 3.57 3.53997 1.25 8.96997 1.25H14.97C20.4 1.25 22.72 3.57 22.72 9V15C22.72 20.43 20.41 22.75 14.97 22.75ZM8.96997 2.75C4.35997 2.75 2.71997 4.39 2.71997 9V15C2.71997 19.61 4.35997 21.25 8.96997 21.25H14.97C19.58 21.25 21.22 19.61 21.22 15V9C21.22 4.39 19.58 2.75 14.97 2.75H8.96997Z"
          fill="currentColorwhite"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M3.26996 20.4495C3.07996 20.4495 2.88996 20.3795 2.73996 20.2295C2.44996 19.9395 2.44996 19.4595 2.73996 19.1695L19.19 2.71945C19.48 2.42945 19.96 2.42945 20.25 2.71945C20.54 3.00945 20.54 3.48945 20.25 3.77945L3.79996 20.2295C3.65996 20.3795 3.46996 20.4495 3.26996 20.4495Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M16.0601 18.75C15.6501 18.75 15.3101 18.41 15.3101 18V13C15.3101 12.59 15.6501 12.25 16.0601 12.25C16.4701 12.25 16.8101 12.59 16.8101 13V18C16.8101 18.41 16.4701 18.75 16.0601 18.75Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M18.5 16.25H13.5C13.09 16.25 12.75 15.91 12.75 15.5C12.75 15.09 13.09 14.75 13.5 14.75H18.5C18.91 14.75 19.25 15.09 19.25 15.5C19.25 15.91 18.91 16.25 18.5 16.25Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M10.5 8.25H5.5C5.09 8.25 4.75 7.91 4.75 7.5C4.75 7.09 5.09 6.75 5.5 6.75H10.5C10.91 6.75 11.25 7.09 11.25 7.5C11.25 7.91 10.91 8.25 10.5 8.25Z"
          fill="currentColor"
          style={{ fill: 'var(--fillg)' }}
        />
      </g>
      <defs>
        <clipPath id="clip0_4418_7409">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Computing;
